const en = {
  eyebrow: 'Get in Touch',
  title: 'Send us a Message',
  description:
    'Tell us about your event — the date, venue and whether you’d like flowers, balloons or both. We reply with ideas and a fixed price, usually the same day.',
  form: {
    name: 'Name',
    email: 'Email',
    eventType: 'Event type',
    selectPlaceholder: 'Select an event type',
    eventTypes: {
      wedding: 'Wedding',
      quinceanera: 'Quinceañera',
      birthday: 'Birthday',
      babyShower: 'Baby Shower',
      corporate: 'Corporate',
      other: 'Other',
    },
    service: 'Service',
    services: { flowers: 'Flowers', balloons: 'Balloons', both: 'Both' },
    date: 'Event date',
    message: 'Message',
    messagePlaceholder: 'Venue, guest count, colors, theme…',
    required: 'required',
    submit: 'Request a Quote',
    sending: 'Sending…',
    hint: 'Prefer to chat? WhatsApp is the fastest way to reach us.',
    success: 'Thank you — your request is in. We’ll reply within a few hours during business hours.',
    errors: {
      name: 'Please tell us your name.',
      email: 'Enter a valid email address.',
      eventType: 'Choose the type of event.',
      message: 'A short description helps us quote accurately.',
    },
  },
  info: {
    online: 'Online now — replies in ~15 min',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    whatsappValue: '(240) 413-8201 · Message us',
    email: 'Email',
    hours: 'Hours',
    hoursLines: ['Monday – Saturday: 9:00 AM – 7:00 PM', 'Sunday: By appointment'],
    area: 'Service area',
    areaValue:
      'Jessup, Columbia, Laurel, Elkridge and surrounding areas within a 15-mile radius. Serving Howard, Anne Arundel & Prince George’s County.',
    directions: 'Get directions',
    mapTitle: 'Map of Jessup, Maryland',
  },
}

const es: typeof en = {
  eyebrow: 'Ponte en Contacto',
  title: 'Envíanos un Mensaje',
  description:
    'Cuéntenos sobre su evento — la fecha, el lugar y si desea flores, globos o ambos. Le respondemos con ideas y un precio fijo, normalmente el mismo día.',
  form: {
    name: 'Nombre',
    email: 'Correo electrónico',
    eventType: 'Tipo de evento',
    selectPlaceholder: 'Seleccione un tipo de evento',
    eventTypes: {
      wedding: 'Boda',
      quinceanera: 'Quinceañera',
      birthday: 'Cumpleaños',
      babyShower: 'Baby Shower',
      corporate: 'Corporativo',
      other: 'Otro',
    },
    service: 'Servicio',
    services: { flowers: 'Flores', balloons: 'Globos', both: 'Ambos' },
    date: 'Fecha del evento',
    message: 'Mensaje',
    messagePlaceholder: 'Lugar, número de invitados, colores, tema…',
    required: 'obligatorio',
    submit: 'Solicitar Cotización',
    sending: 'Enviando…',
    hint: '¿Prefiere escribir? WhatsApp es la forma más rápida de contactarnos.',
    success: 'Gracias — recibimos su solicitud. Le responderemos en pocas horas durante el horario de atención.',
    errors: {
      name: 'Por favor indíquenos su nombre.',
      email: 'Ingrese un correo electrónico válido.',
      eventType: 'Elija el tipo de evento.',
      message: 'Una breve descripción nos ayuda a cotizar con precisión.',
    },
  },
  info: {
    online: 'En línea ahora — respuesta en ~15 min',
    phone: 'Teléfono',
    whatsapp: 'WhatsApp',
    whatsappValue: '(240) 413-8201 · Escríbanos',
    email: 'Correo',
    hours: 'Horario',
    hoursLines: ['Lunes – Sábado: 9:00 AM – 7:00 PM', 'Domingo: Por cita'],
    area: 'Área de servicio',
    areaValue:
      'Jessup, Columbia, Laurel, Elkridge y alrededores dentro de un radio de 15 millas. Servimos los condados de Howard, Anne Arundel y Prince George’s.',
    directions: 'Cómo llegar',
    mapTitle: 'Mapa de Jessup, Maryland',
  },
}

export const contact = { en, es }
